module.exports = __webpack_public_path__ + "images/button_small_horizontal_blank_4cf0315b2c7a78680527973609b0217d.svg";